// /Store/cardStore.js
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCardStore = defineStore('cardStore', () => {
  const selectedCard = ref(null)

  const setSelectedCard = (card) => {
    selectedCard.value = card
  }

  return { selectedCard, setSelectedCard }
})
